import _ from 'lodash';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface NodeMenuStore {
  menuOpen: boolean;
  anchorEl: any | null;

  targetNodeId: string | null;
  targetNodeHeight: number | null;
  targetNodePath: 'success' | 'failure' | null;
  targetNodePosition: { x: number; y: number } | null;
  fromEdge: boolean;

  handleOpenMenu(el: any, nodeId?: string, position?: { x: number; y: number }, height?: number, path?: 'success' | 'failure', fromEdge?: boolean): () => void;

  handleCloseMenu(): void;
}

const useBottomNodeMenuStore = createWithEqualityFn<NodeMenuStore>(
  (set) => ({
    menuOpen: false,
    anchorEl: null,
    targetNodeId: null,
    targetNodeHeight: null,
    targetNodePath: null,
    targetNodePosition: null,
    fromEdge: false,

    handleOpenMenu(el: any, nodeId?: string, position?: { x: number; y: number }, height?: number, path?: 'success' | 'failure', fromEdge?: boolean) {
      return () => {
        set(() => ({
          menuOpen: true,
          anchorEl: el,
          targetNodeId: !_.isNil(nodeId) ? nodeId : null,
          targetNodeHeight: !_.isNil(height) ? height : null,
          targetNodePath: !_.isNil(path) ? path : null,
          targetNodePosition: !_.isNil(position) ? position : null,
          fromEdge: !_.isNil(fromEdge) ? fromEdge : false,
        }));
      };
    },

    handleCloseMenu() {
      set(() => ({ menuOpen: false, anchorEl: null, targetNodeId: null, targetNodeHeight: null, targetNodePath: null, targetNodePosition: null }));
    },
  }),
  shallow
);

export default useBottomNodeMenuStore;
